/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* See [Browser Service](https://docs.xandr.com/bundle/xandr-api/page/browser-service.html) in Xandr's documentation.
*/
export class V3BrowserTarget {
    /**
    * ID of the browser.
    */
    'id'?: number;
    /**
    * Name of the browser.
    */
    'name'?: string;
    /**
    * The time the browser was last modified.
    */
    'lastModified'?: Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastModified",
            "baseName": "last_modified",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return V3BrowserTarget.attributeTypeMap;
    }

    public constructor() {
    }
}

